// Configuration for the application
export const config = {
  API_BASE_URL: process.env.REACT_APP_API_BASE_URL || 'http://localhost:3001/api',
  SHARED_SECRET: process.env.REACT_APP_SHARED_SECRET || 'your-shared-secret-key-here'
};